import { useQuery } from "@apollo/client";
import { OrderHeaderAssortmentDetailsDoc, WorkspaceNameDoc } from "operations";
import { HeaderPageView } from "../WorkspaceOrderHeader";

export type BreadCrumbNavData = {
  workspaceName?: string;
  workspaceId?: string;
  assortmentName?: string;
  loading: boolean;
};

export const useQueryData = (
  workspaceId: string,
  assortmentId: string,
  view: HeaderPageView
): BreadCrumbNavData => {
  const workspaceData = useQuery(WorkspaceNameDoc, {
    variables: { workspaceId },
    skip: view !== "workspace",
  });
  const assortmentData = useQuery(OrderHeaderAssortmentDetailsDoc, {
    variables: { assortmentId },
    skip: view === "workspace",
  });
  return view === "workspace"
    ? {
        workspaceName: workspaceData.data?.retailWorkspace?.name,
        workspaceId: workspaceData.data?.retailWorkspace?.id,
        loading: workspaceData.loading,
      }
    : {
        workspaceName: assortmentData.data?.assortment?.workspace?.name,
        workspaceId: assortmentData.data?.assortment?.workspace?.id,
        loading: assortmentData.loading,
        assortmentName: assortmentData.data?.assortment?.name,
      };
};
